import { SubmitStyled } from "@/components/UI/Form/Submit/Submit.styled";
import {useFormikContext} from "formik";

const Submit = ({ children, ...props }) => {
    const {isSubmitting} = useFormikContext()

    return (
        <SubmitStyled {...props} type="submit" loading={isSubmitting}>
            {children}
        </SubmitStyled>
    );
};

export default Submit;
